import React from "react";
import { NavLink } from 'react-router-dom';
import styles from './nav.module.less';

function Nav(){
    return (
        <div className={styles.nav}>
              <ul>
                    <li><NavLink to="/About" >About</NavLink></li>
                    <li><NavLink to="/Experience" >Experience</NavLink></li>
                    <li><NavLink to="/Resume" >Resume</NavLink></li>
                    <li><NavLink to="/Skills" >Skills</NavLink></li>
                    <li><NavLink to="/Articles" >Articles</NavLink></li>
              </ul>
        </div>
    );
}

export default Nav;